module.exports = __webpack_public_path__ + "static/media/position_store.c30e95ef.svg";